import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getSecureData, removeSecureItem } from "../../helpers";
import { setupUserProfileData } from "../../helpers/userProfileSetup";

export default function ResumeSetup() {
  const navigate = useNavigate();

  useEffect(() => {
    const resume = async () => {
      const resumeFlag = await getSecureData("_resume_profile_setup");
      
      if (resumeFlag) {
        const practiceInfo = await getSecureData("practiceInfo");
        const redirected = await setupUserProfileData(practiceInfo, { navigate });

        if (redirected) return;
      }

      await removeSecureItem("_resume_profile_setup");

      navigate("/", { replace: true });
    };

    resume();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
